import CreateDrivers from '../../components/drivers/CreateDriver'
import { connect } from 'react-redux'
import { ICreateDriver } from '../../types'
import { addDriverInfo } from '../../state/actions/drivers'
import { getDriverProcessing, getDriverProcessingError } from '../../state/reducers/drivers'

export function mapStateToProps(state: any) {
  const organizationId = state.organizations ? state.organizations.currentOrgId : undefined
  return {
    stepsCreateDriver: state.drivers.stepsCreateDriver,
    processing: getDriverProcessing(state),
    processingError: getDriverProcessingError(state),
    organizationId
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    addDriverInfo: (data: ICreateDriver) => dispatch(addDriverInfo(data))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateDrivers)



// WEBPACK FOOTER //
// ./src/containers/drivers/CreateDrivers.ts